import React from 'react'
import PropTypes from 'prop-types'

import './PhotoCard.css'

const PhotoCard = ({ image, headline, subtitle }) => {
  return (
    <div className="fmbm-photocard">
      <img src={image} className="wow slideInUp" alt="" />
      <div>
        <h2>{headline}</h2>
        <p>{subtitle}</p>
      </div>
    </div>
  )
}

PhotoCard.propTypes = {
  image: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
}

export default PhotoCard



// WEBPACK FOOTER //
// ./src/Components/PhotoCard/PhotoCard.js